import React, { useEffect, useRef, useState } from "react";
import "@lottiefiles/lottie-player";
import { create } from "@lottiefiles/lottie-interactivity";
import lottieJson from "../assets/m-01-11.json";
import clickIcon from "../assets/images/click.png";
import logo from "../assets/images/logo.svg";
import videoFile from "../assets/Mobile-M01-02.m4v"
import poster from "../assets/images/poster.png"

const Header = () => {
  const lottieRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isLooping, setIsLooping] = useState(false);
  // const [key, setKey] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      // setKey((prevKey) => prevKey + 1);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile && lottieRef.current) {
      create({
        player: lottieRef.current,
        mode: "chain",
        actions: [
          {
            state: "autoplay",
            transition: "pauseHold",
            frames: "first",
          },
          {
            state: "loop",
            transition: "click",
            frames: "loop",
          },
          {
            state: "autoplay",
            frames: "last",
          },
        ],
      });
    }
  }, [isMobile]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLooping(true);
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  const handleLottieClick = () => {
    setIsLooping(false);
    if (lottieRef.current) {
      lottieRef.current.click();
    }
  };

  return (
    <div className="headerContainer" style={{cursor:isLooping?"pointer":"unset"}}>
      <div className="logoContainer">
        <a href="https://pakshoma.com" target="blank">
          <img src={logo} alt="logo icon" loading="lazy"/>
        </a>
      </div>
      {isMobile ? (
        // <lottie-player
        //   key={key}
        //   src={lottieJson2}
        //   autoplay
        //   loop={false}
        //   style={{
        //     width: "100%",
        //     height: "auto",
        //   }}
        // ></lottie-player>
        <video src={videoFile} muted autoPlay={true} playsInline={true} loop={false} poster={poster} style={{width:"100%"}}/>

      ) : (
        <lottie-player
          ref={lottieRef}
          src={lottieJson}
          autoplay
          loop={false}
          style={{
            width: "100%",
            height: "auto",
          }}
          onClick={handleLottieClick}
        ></lottie-player>
      )}

      {isLooping && !isMobile && (
        <button className="clickIcon" onClick={handleLottieClick}>
          <img src={clickIcon} alt="click icon" loading="lazy"/>
          کلیک کنید
        </button>
      )}
    </div>
  );
};

export default Header;


{
  /* <img src={logo} alt="logo icon" />

    <h1>کنار هم، کامــــــل‌تریم</h1>

    <p>یخچال فریزر دوقلو پاکشوما | سری Twin Peaks</p> */
}

{
  /* <img src={header} alt="header image" /> */
}
